/**
 * Checkout complete lifecycle — cancels payment status polling on dispose (GC-P0-03).
 */
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTenantCode } from '../../shared/tenant/TenantProvider.js';
import { ScreenLifecycle } from '../../shared/screen/ScreenLifecycle.js';
import { CheckoutCompleteRoute } from './CheckoutCompleteRoute.js';

export function CheckoutCompleteRouteLifecycle(): JSX.Element {
  const queryClient = useQueryClient();
  const tenantCode = useTenantCode();
  const onDisposed = useCallback(() => {
    void queryClient.cancelQueries({ queryKey: ['customer', tenantCode] });
  }, [queryClient, tenantCode]);

  return (
    <ScreenLifecycle screenId="MS-COM-032" onDisposed={onDisposed}>
      <CheckoutCompleteRoute />
    </ScreenLifecycle>
  );
}
